// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ProtectedRoute from './ProtectedRoute';
// import MainLayout from '../layouts/MainLayout';
// import Login from '../pages/Login/Login';
// import Dashboard from '../pages/Dashboard/Dashboard';
// // import Users from '../pages/Users/Users';
// import Clients from '../pages/Users/Clients';
// import Admins from '../pages/Users/Admins';
// import Languages from '../pages/Languages/Language';
// import Services from '../pages/Services/Services';
// import Translators from '../pages/Translators/Translator';
// import Projects from '../pages/Projects/Projects';
// import BidsPage from '../pages/Projects/BidsPage';
// import BidManagement from '../pages/Projects/BidManagement';
// import QuotationManagement from '../pages/Projects/QuotationManagement';
// import AssignmentManagement from '../pages/Projects/AssignmentManagement';
// import ProjectRequestPage from '../pages/ProjectRequest/ProjectRequestPage';
// import PendingProjectsPage from '../pages/Projects/PendingProjects';

// const AppRouter = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/project-request" element={<ProjectRequestPage />} /> {/* Add this */}
//         <Route element={<ProtectedRoute />}>
//           <Route element={<MainLayout />}>
//             <Route path="/" element={<Dashboard />} />
//             {/* <Route path="/users" element={<Users />} /> */}
//             <Route path="/clients" element={<Clients />} />
//             <Route path="/admins" element={<Admins />} />
//             <Route path="/languages" element={<Languages />} />
//             <Route path="/services" element={<Services />} />
//             <Route path="/translators" element={<Translators />} />
//             <Route path="/projects" element={<Projects />} />
//             <Route path="/projects/:projectId/bids" element={<BidsPage />} />
//             <Route path="/projects/:projectId/manage-bids" element={<BidManagement />} />
//             <Route path="/projects/:projectId/quotations" element={<QuotationManagement />} />
//             <Route path="/projects/:projectId/assignments" element={<AssignmentManagement />} />
//             <Route path="/pending-projects" element={<PendingProjectsPage />} /> {/* Add this */}

//           </Route>
//         </Route>
//       </Routes>
//     </Router>
//   );
// };

// export default AppRouter;

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from '../layouts/MainLayout';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import Clients from '../pages/Users/Clients';
import Admins from '../pages/Users/Admins';
import Languages from '../pages/Languages/Language';
import Services from '../pages/Services/Services';
import Translators from '../pages/Translators/Translator';
import Projects from '../pages/Projects/Projects';
import BidsPage from '../pages/Projects/BidsPage';
import BidManagement from '../pages/Projects/BidManagement';
import QuotationManagement from '../pages/Projects/QuotationManagement';
import AssignmentManagement from '../pages/Projects/AssignmentManagement';
import ProjectRequestPage from '../pages/ProjectRequest/ProjectRequestPage';
import PendingProjectsPage from '../pages/Projects/PendingProjects';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/project-request" element={<ProjectRequestPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/admins" element={<Admins />} />
            <Route path="/languages" element={<Languages />} />
            <Route path="/services" element={<Services />} />
            <Route path="/translators" element={<Translators />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId/bids" element={<BidsPage />} />
            <Route path="/projects/:projectId/manage-bids" element={<BidManagement />} />
            <Route path="/projects/:projectId/quotations" element={<QuotationManagement />} />
            <Route path="/projects/:projectId/assignments" element={<AssignmentManagement />} />
            <Route path="/pending-projects" element={<PendingProjectsPage />} />
          </Route>
        </Route>
        {/* Fallback route for undefined paths */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
    </Router>
  );
};

export default AppRouter;